import { Helmet } from "react-helmet-async"
import { ErrorView } from "shared/ui/errorView"
import React from "react"

// ----------------------------------------------------------------------

export function Page404(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>404 - страница не найдена</title>
      </Helmet>

      <ErrorView
        label="404"
        title="Вы нашли секретное место"
        description="К сожалению, это всего лишь страница 404. Возможно, вы ошиблись при вводе адреса или страница была перемещена
        по другому URL-адресу."
      />
    </>
  )
}
